import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Downshift from 'downshift'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Paper from '@material-ui/core/Paper'
import MenuItem from '@material-ui/core/MenuItem'
import Chip from '@material-ui/core/Chip'

function renderInput(inputProps) {
  const { InputProps, classes, ref, ...other } = inputProps

  return (
    <TextField
      InputProps={{
        inputRef: ref,
        classes: {
          root: classes.inputRoot
        },
        ...InputProps
      }}
      {...other}
    />
  )
}

function renderSuggestion({
  customer,
  index,
  itemProps,
  highlightedIndex,
  selectedItem
}) {
  const isHighlighted = highlightedIndex === index
  const isSelected = selectedItem
    ? (selectedItem.key || '').indexOf(customer.key) > -1
    : false
  return (
    <MenuItem
      {...itemProps}
      key={customer.key}
      selected={isHighlighted}
      component="div"
      style={{
        fontWeight: isSelected ? 500 : 400
      }}>
      {`${customer.customers_first_name} ${customer.customers_last_name}`}
    </MenuItem>
  )
}
renderSuggestion.propTypes = {
  highlightedIndex: PropTypes.number,
  index: PropTypes.number,
  itemProps: PropTypes.object,
  selectedItem: PropTypes.string,
  customer: PropTypes.shape({
    key: PropTypes.string,
    customers_first_name: PropTypes.string,
    customers_last_name: PropTypes.string
  }).isRequired
}

function getSuggestions(inputValue, customers) {
  let count = 0

  return customers.filter(customer => {
    const keep =
      (!inputValue ||
        (customer.customers_first_name
          .toLowerCase()
          .indexOf(inputValue.toLowerCase()) !== -1 ||
          customer.customers_last_name
            .toLowerCase()
            .indexOf(inputValue.toLowerCase()) !== -1)) &&
      count < 5

    if (keep) {
      count += 1
    }

    return keep
  })
}

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: 250
  },
  container: {
    flexGrow: 1,
    position: 'relative'
  },
  paper: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing.unit,
    left: 0,
    right: 0
  },
  chip: {
    margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`
  },
  inputRoot: {
    flexWrap: 'wrap'
  }
})

class SearchCustomerComponent extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    customers: PropTypes.array.isRequired,
    selectedCustomer: PropTypes.object,
    onSelection: PropTypes.func.isRequired
  }
  static defaultProps = {
    selectCustomer: void 0
  }
  state = {
    inputValue: '',
    selectedItem: void 0
  }
  componentDidMount() {
    if (this.props.selectedCustomer) {
      this.setState({ selectedItem: this.props.selectedCustomer })
    }
  }
  componentWillReceiveProps(nextProps) {
    if (
      this.props.selectedCustomer &&
      nextProps.selectedCustomer &&
      this.props.selectedCustomer.key !== nextProps.selectedCustomer.key
    ) {
      this.setState({ selectedItem: nextProps.selectedCustomer })
    }
  }
  handleInputChange = event => {
    this.setState({ inputValue: event.target.value })
  }
  handleChange = item => {
    this.setState({ selectedItem: item, inputValue: '' })
    this.props.onSelection({ target: { value: item } })
  }
  handleDelete = e => {
    this.setState({ selectedItem: void 0 })
    this.props.onSelection({ target: { value: void 0 } })
  }
  itemToString = item => {
    return `${(item || {}).customers_first_name} ${
      (item || {}).customers_last_name
    }`
  }
  render() {
    const { classes, customers } = this.props
    const { inputValue, selectedItem } = this.state
    return (
      <Downshift
        itemToString={this.itemToString}
        inputValue={inputValue}
        onChange={this.handleChange}
        selectedItem={selectedItem}>
        {({
          getInputProps,
          getItemProps,
          isOpen,
          inputValue,
          selectedItem,
          highlightedIndex
        }) => (
          <div className={classes.container}>
            {renderInput({
              fullWidth: true,
              classes,
              InputProps: getInputProps({
                startAdornment: this.state.selectedItem && (
                  <Chip
                    tabIndex={-1}
                    label={`${selectedItem.customers_first_name} ${
                      selectedItem.customers_last_name
                    }`}
                    className={classes.chip}
                    onDelete={this.handleDelete}
                  />
                ),
                disabled: !!this.state.selectedItem,
                onChange: this.handleInputChange,
                onKeyDown: this.handleKeyDown,
                placeholder: 'Rechercher un client',
                id: 'integration-downshift-simple'
              })
            })}
            {isOpen ? (
              <Paper className={classes.paper} square>
                {getSuggestions(inputValue, customers).map((customer, index) =>
                  renderSuggestion({
                    customer,
                    index,
                    itemProps: getItemProps({ item: customer }),
                    highlightedIndex,
                    selectedItem
                  })
                )}
              </Paper>
            ) : null}
          </div>
        )}
      </Downshift>
    )
  }
}
const mapStateToProps = state => {
  return {
    customers: state.customers.list
  }
}

export default connect(mapStateToProps, {})(
  withStyles(styles)(SearchCustomerComponent)
)



// WEBPACK FOOTER //
// ./src/components/customer/SearchCustomerComponent.js